import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { applyBranding } from "./lib/branding";

// Best-effort white-label branding (custom domains only) — non-blocking.
applyBranding();

createRoot(document.getElementById("root")!).render(<App />);
